import { Component, OnInit } from '@angular/core';
import { ProdutoService, DadosService } from '../services/service';
import { Produto, Usuario } from '../models/model';
import { Router, ActivatedRoute } from '@angular/router';
import { DadosComponent } from 'app/dados/dados.component';

@Component({
  selector: 'app-produto',
  templateUrl: './produto_pesquisa.component.html',
  styleUrls: ['./produto_pesquisa.component.css']
})
export class ProdutoPesquisaComponent implements OnInit {

  produtos: Produto[] = [];

  pesquisando: boolean = false;

  cnpj = "";

  constructor(private produtoService: ProdutoService,
              private dadosService: DadosService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
  }

  buscaProduto(filtroProduto: any) {
    this.pesquisando = true;
    if (filtroProduto.referencia != '') {
      filtroProduto.referencia = this.removerAcentos(filtroProduto.referencia.toUpperCase());
    }
    if (filtroProduto.produto != '') {
      filtroProduto.produto = '%'+ this.removerAcentos(filtroProduto.produto.toUpperCase()) + '%';
    }
    this.produtoService.buscaProduto(filtroProduto).subscribe((prods) => {
      this.produtos = prods;
      this.pesquisando = false;
    }, (error) => this.pesquisando = false);
  }

  getLogo() {
    return "assets/img/" + this.dadosService.getEmpresa().cnpj_sem_mascara + ".png";
  }

  removerAcentos( newStringComAcento ) {
    var string = newStringComAcento;
    var mapaAcentosHex = {
      a : /[\xE0-\xE6]/g,
      A : /[\xC0-\xC6]/g,
      e : /[\xE8-\xEB]/g,
      E : /[\xC8-\xCB]/g,
      i : /[\xEC-\xEF]/g,
      I : /[\xCC-\xCF]/g,
      o : /[\xF2-\xF6]/g,
      O : /[\xD2-\xD6]/g,
      u : /[\xF9-\xFC]/g,
      U : /[\xD9-\xDC]/g,
      c : /\xE7/g,
      C : /\xC7/g,
      n : /\xF1/g,
      N : /\xD1/g,
      };
  
    for ( var letra in mapaAcentosHex ) {
      var expressaoRegular = mapaAcentosHex[letra];
      string = string.replace( expressaoRegular, letra );
    }
  
    return string;
  }

}



// WEBPACK FOOTER //
// ./src/app/produto_pesquisa/produto_pesquisa.component.ts